module finadai.app.admin.create {
    import ProxyRecord = models.http.responses.ProxyRecord;
    export var NAME = "finadai.app.admin.create"

    function AdminCreateController(customersService: services.CustomersService,
                                   whoIAm: models.User, $rootScope, $scope,
                                   notify, confirm, $mdDialog: ng.material.IDialogService,
                                   $state: ng.ui.IStateService, negotiationsService: services.NegotiationsService,
                                   proxifier, $q: ng.IQService, authService: services.AuthService) {
        $scope.formData = {};
        $scope.negotiationData = {};
        $scope.searchComplete = false;
        $scope.searchingInProgress = false;
        $scope.sendingNegotiation = false;
        $scope.oxxoReferenceUpdate = "";
        $scope.displayOxxoOption = false;
        $scope.negotiationData.want_oxxo = 1;
        $scope.plazos = [
            {id: 3, name: 'Semana'},
            {id: 4, name: 'Catorcena'},
            {id: 1, name: 'Mes'},
            {id: 5, name: 'Dia'}
        ];
        $scope.quieresOxxos = [
            {id: 1, name: 'Si'},
            {id: 0, name: 'No'}
        ];
        $scope.formasDePagos = [
            {id: 1, name: 'Oxxo'},
            {id: 0, name: 'Banco'}
        ];
        let msgCustomer = "";
        $scope.canCreateNegotiationForCustomer = whoIAm.operations.indexOf('admin_create_negotiation') >= 0;
        $scope.changeWantOxxo = () => {
            if ($scope.negotiationData.payment_type.id == 0) {
                $scope.displayOxxoOption = true;
            } else {
                $scope.displayOxxoOption = false;
            }
        };
        $scope.submitNegotiation = (form) => {
            if (form.$valid) {
                $scope.oxxoReferenceUpdate = "";
                $scope.sendingNegotiation = true;
                customersService.proxySaveManualNegotiation({
                    customer_number: $scope.negotiationData.customer_number,
                    payment_amount: $scope.negotiationData.payment_amount,
                    term: $scope.negotiationData.term.id,
                    payment_type: $scope.negotiationData.payment_type.id,
                    want_oxxo: $scope.negotiationData.want_oxxo.id,
                    num_payments: $scope.negotiationData.num_payments,
                    observation_code: $scope.negotiationData.observation_code,
                    phone: $scope.negotiationData.cellphone,
                    email: $scope.negotiationData.email,
                    source: $scope.negotiationData.source,
                    user_id: whoIAm.id
                }).then(function (response) {
                    console.log(response);
                    notify('Negociación Creada');
                    $scope.sendingNegotiation = false;
                    this.negotiationForm.reset();
                    $scope.negotiationData.customer_number = "";
                    $scope.negotiationData.payment_amount = "";
                    $scope.negotiationData.num_payments = "";
                    $scope.negotiationData.observation_code = "";
                    $scope.negotiationData.cellphone = "";
                    $scope.negotiationData.email = "";
                    $scope.negotiationData.source = "";
                    if(response.data.Data.Encabezado.ReferenciaOxxo>0) {
                        $scope.oxxoReferenceUpdate = "Nueva Referencia OXXOPay Solicitada: " + response.data.Data.Encabezado.ReferenciaOxxo;
                    }
                }, function (response) {
                    console.log(response);
                    notify('Fallo Crear Negociación', 'danger');
                    $scope.sendingNegotiation = false;
                })
            }
        };
    }

    export function run() {
        var create = angular.module(NAME, [])
        create.controller("AdminCreateController", AdminCreateController)
    }
}
finadai.app.admin.create.run();
